export default __webpack_public_path__ + "static/media/gmap.507a6beb.png";